import { api } from '@/api';

export interface GetActiveUsersForOrgResponse {
  activeUsers: ActiveUsersForOrgUser[];
}

export interface ActiveUsersForOrgUser {
  fletchUserId: string;
  userName: string;
  /** Not on the backend yet; pickers show it after a name that more than one user has. */
  email?: string;
}

const getActiveUsersForOrgApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getActiveUsersForOrg: builder.query<GetActiveUsersForOrgResponse, void>({
      query: () => ({
        url: `users/list-active`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetActiveUsersForOrgQuery } = getActiveUsersForOrgApi;
